import { useTypedNode } from './useTypedNode'

import type { Store } from '@rehaje/core'

/**
 * 获取当前渲染的 rehaje Store
 */
export function useStore(): Store | undefined {
  return useTypedNode()?.getStore()
}
